import { MenuItem } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { statusVariants } from '../../constans';

import { InputField } from './input-field';
import { StatusBadge } from './status-badge';

import { VisitState } from '@/features/visits/api/types/visits';

interface Option {
  color: string;
  label: string;
  value: VisitState;
  onClick?: () => void;
}

interface StatusSelectProps {
  options: Option[];
  onClick?: (statusToSet: string) => void;
  value: string;
  label?: string;
  defaultValue?: Option;
}

export const StatusSelect: FC<StatusSelectProps> = props => {
  const { options = [], onClick, value, defaultValue, ...other } = props;
  const { t } = useTranslation(['common']);
  const defaultDisabledStatusBadge = () => {
    const statusVariant = statusVariants.find(el => el.value === defaultValue?.value);

    return (
      <MenuItem
        key="default"
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
        value={statusVariant?.value}
        disabled={true}>
        <StatusBadge
          color={statusVariant?.color || ''}
          sx={{
            backgroundColor: statusVariant?.color,
            mr: 1,
          }}
        />
        {t(`common:statusVariants.${statusVariant?.value || 'created'}`)}
      </MenuItem>
    );
  };

  return (
    <InputField fullWidth select value={value} {...other}>
      {defaultValue && defaultDisabledStatusBadge()}
      {options.map(option => (
        <MenuItem
          key={option.value}
          sx={{
            alignItems: 'center',
            display: 'flex',
          }}
          value={option.value}
          onClick={() => onClick?.(option.value)}>
          <StatusBadge
            color={option.color}
            sx={{
              backgroundColor: option.color,
              mr: 1,
            }}
          />
          {t(`common:statusVariants.${option.value}`)}
        </MenuItem>
      ))}
    </InputField>
  );
};
